import { tv } from 'tailwind-variants';
import { cn } from '@/shared/utils';

interface IconTextItemProps {
  icon?: string;
  title: string;
  name?: string;
  titleClassName?: string;
  iconClassName?: string;
  className?: string;
  variant?: 'default' | 'compact' | 'compact-md';
}

const iconTextItemVariants = tv({
  slots: {
    container: 'flex items-center min-w-0',
    icon: 'rounded-full object-contain',
    title: 'flex-1 text-left',
    name: 'text-muted-foreground text-left',
  },
  variants: {
    variant: {
      default: {
        container: 'gap-[1.6rem]',
        icon: 'w-[4.4rem] h-[4.4rem]',
        title: 'headline4',
        name: 'p5',
      },
      compact: {
        container: 'gap-[0.8rem]',
        icon: 'w-[1.8rem] h-[1.8rem]',
        title: 'p3 truncate',
        name: 'p3',
      },
      'compact-md': {
        container: 'gap-[0.8rem]',
        icon: 'w-[2.4rem] h-[2.4rem]',
        title: 'headline4 truncate',
        name: 'p3',
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export function IconTextItem({
  icon,
  title,
  name,
  iconClassName,
  titleClassName,
  className,
  variant = 'default',
}: IconTextItemProps) {
  const {
    container,
    icon: iconSlot,
    title: titleSlot,
    name: nameSlot,
  } = iconTextItemVariants({ variant });

  const iconItem = icon && (
    <img
      src={icon}
      alt={title}
      className={cn(iconSlot(), iconClassName)}
      loading="lazy"
    />
  );

  if (variant === 'compact' || variant === 'compact-md') {
    return (
      <div className={cn(container(), className)}>
        {iconItem}
        <span className={cn(titleSlot(), titleClassName)}>{title}</span>
        {name && <span className={nameSlot()}>{name}</span>}
      </div>
    );
  }

  return (
    <div className={cn(container(), className)}>
      {iconItem}
      <div className="flex flex-col justify-center flex-1">
        <span className={titleSlot()}>{title}</span>
        {name && <span className={nameSlot()}>{name}</span>}
      </div>
    </div>
  );
}
